"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useBlogListAnimation(gridRef, animationKey) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== animationKey || $[1] !== gridRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      if (!animationKey) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const grid = gridRef.current;
        if (!grid) {
          return;
        }
        const cards = gsap.utils.toArray(grid.querySelectorAll(".blog-card:not([data-animated-in='true'])"));
        if (cards.length === 0) {
          return;
        }
        const hasAnimatedCards = grid.querySelector(".blog-card[data-animated-in='true']");
        gsap.set(cards, {
          x: 160,
          y: 50,
          opacity: 0,
          scale: 0.94,
          rotateY: -14,
          filter: "blur(10px)",
          transformPerspective: 1200,
          transformOrigin: "center right"
        });
        const markAsAnimated = () => {
          for (const card of cards) {
            card.dataset.animatedIn = "true";
          }
        };
        const baseAnimation = {
          x: 0,
          y: 0,
          opacity: 1,
          scale: 1,
          rotateY: 0,
          filter: "blur(0px)",
          duration: 1.15,
          stagger: 0.09,
          ease: "power4.out",
          clearProps: "filter",
          onComplete: markAsAnimated
        };
        const tween = hasAnimatedCards ? gsap.to(cards, baseAnimation) : gsap.to(cards, {
          ...baseAnimation,
          delay: 0.65,
          scrollTrigger: {
            trigger: grid,
            start: "top 105%",
            once: true
          }
        });
        cleanup = () => {
          tween.scrollTrigger?.kill();
          tween.kill();
        };
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [animationKey, gridRef];
    $[0] = animationKey;
    $[1] = gridRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}